<template>
  <div id="wuPage" class="questionBank">
    <a-table
      ref="table"
      bordered
      size="middle"
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="htmlSlot" slot-scope="text">
        <a-popover title="题干预览" placement="right">
          <div slot="content" v-html="text"></div>
          <a-icon type="eye" theme="twoTone" />
        </a-popover>
      </template>

      <span slot="action" slot-scope="text, record">
        <a @click="toQuestion(record)">去做题</a>
      </span>
    </a-table>
  </div>
</template>

<script>
import { JeecgListMixin } from "@/utils/JeecgListMixin";
import { getAction } from "@/api/manage";
export default {
  name: "questionBank",
  mixins: [JeecgListMixin],
  data() {
    return {
      columns: [
        {
          title: "#",
          dataIndex: "",
          key: "rowIndex",
          width: 60,
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          },
        },
        // {
        //   title: "题型",
        //   align: "center",
        //   dataIndex: "questionType_dictText",
        // },
        {
          title: "题目名",
          align: "center",
          dataIndex: "questionName",
        },
        {
          title: "题干",
          align: "center",
          dataIndex: "questionStem",
          width: 70,
          scopedSlots: { customRender: "htmlSlot" },
        },
        {
          title: "难度",
          align: "center",
          width: 70,
          dataIndex: 'questionDifficulty_dictText'
        },
        {
          title: "分值",
          align: "center",
          width: 80,
          dataIndex: "questionScore",
        },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          align: "center",
          width: 100,
          scopedSlots: { customRender: "action" },
        },
      ],
      url: {
        list: "/teaching/teachingQuestion/getMyPublicList",
      },
      disableMixinCreated: true, //禁用mixin的created方法
      unitInfo: {},
    };
  },
  created() {
    this.search();
  },
  methods: {
    search() {
      this.loading = true;
      this.loadData(1);
    },
    toQuestion(q) {
        console.log(q , 'qqqq')
      window.open("/onlinecode/index.html?questionId=" + q.questionId);
    },
  },
};
</script>

<style >
.questionBank{
    padding: 20px;
}
</style>